import React, { useState, useEffect } from 'react';

import { Layout, Avatar, Menu, Card, Dropdown, Row, Col, Typography, Popover, Spin, Tooltip } from 'antd';
import {
	UserOutlined,
	LogoutOutlined,
} from '@ant-design/icons';

// import {
//     rankItem,
// } from '@tanstack/match-sorter-utils'

// import {
//     flexRender,
//     getCoreRowModel,
//     getFilteredRowModel,
//     useReactTable,
// } from '@tanstack/react-table'


import { errorCatch, GET, JSXMap, QueryDetail, READWITH, ycStorage } from 'fennec-ui';
import useStyles from '../../../common/Styles';

import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from 'fennec-ui';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'

import { useDispatch, useSelector } from 'react-redux';
import REDUX_AkkauntiPolzovatelei from '../../../objects/AkkauntiPolzovatelei/reducer';
import { MetaContext } from 'fennec-ui';
import Icofont from 'react-icofont';
import REDUX_UserConfig from '../../../objects/UserConfig/reducer'
import REDUX_Translate from '../../../objects/Translate/reducer';
import { convertEventResult, getIndexColor, getIndexColorLighter, translate, ycBucket } from '../../../common/Tool';
import YImage from '../../../common/YImage';
import { useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext } from '../../../common/Context';
import CategoryName from '../../components/CategoryName';

var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

var _ = require('lodash');
const { SubMenu } = Menu;

const { Header, Content, Footer, Sider } = Layout;

const FedHeader = (props) => {
	let navigate = useNavigate();
	const auth = useAuth();
	const dispatch = useDispatch();
	const userConfig = useSelector(REDUX_UserConfig.selector.object) || {};
	const translates = useSelector(REDUX_Translate.selector.object);
	const t = React.useMemo(() => _.bind(translate, {
		translate: translates,
		config: userConfig
	}), [translates, userConfig]);
	// const t = useTranslateContext();
	// console.log(t("да"));

	const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
	const isMobile = useIsMobileContext();
	const isDesktopOrLaptop = useIsDesktopOrLaptopContext();

	const { layout, fullwidth, user, logout, logoutall } = props;
	let lsDiv = (fullwidth || !isDesktopOrLaptop) ? {} : { width: layoutWidth, margin: "0 auto" };
	let lsHeader = (layout === "web") ? { background: "white" } : {};
	let lsFontColor = (layout === "web") ? { color: "rgb(0 0 0 / 65%)" } : { color: "rgba(255, 255, 255, 0.65)" };

	const akkauntiPolzovatelei = useSelector(REDUX_AkkauntiPolzovatelei.selector.array);
	const balance = (akkauntiPolzovatelei) => {
		let v = _.get(akkauntiPolzovatelei, "[0].akkaunt.ostatok")
		if (v) return v;
		return 0;
	};
	const _menu = () => {
		let menu = [];
		menu.push({
			key: 'web',
			label: (<a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/fed/events`} style={{ display: "flex", justifyContent: "space-between" }}>
				<div><i className="fa fa-globe" style={{ paddingRight: "4px", color: "blue" }}></i> {t("Главный сайт")}</div>
			</a>),
		});
		menu.push({
			key: 'lk',
			label: (<a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app`} style={{ display: "flex", justifyContent: "space-between" }}>
				<div><Icofont icon="home" style={{ paddingRight: "8px", color: "orange" }} />{t("Личный кабинет")}</div>
			</a>),
		});
		menu.push({
			key: 'jack',
			label: (<a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://${auth.getDomainWithoutSubdomain(window.location.href)}/app/switch`} style={{ display: "flex", justifyContent: "space-between" }}>
				<div><Icofont icon="ui-calendar" style={{ paddingRight: "4px", color: "green" }} /> {t("Войти в мероприятие")}</div>
			</a>),
		});
		menu.push({
			key: 'profile',
			label: (<a target="_blank" rel="noopener noreferrer" href={`${auth.authschemhttp}://auth.${auth.getDomainWithoutSubdomain(window.location.href)}/common/profile`} style={{ display: "flex", justifyContent: "space-between" }}>
				<div><Icofont icon="user" style={{ paddingRight: "4px" }} /> {t("Профиль")}</div>
			</a>),
		});
		menu.push({
			type: 'divider',
		});
		menu.push({
			key: 'logout',
			label: (
				<div style={{ display: "flex", justifyContent: "space-between" }} onClick={logout}>
					<div><LogoutOutlined /> Выход</div>
					<div style={{ flex: 0, color: "red" }} onClick={logoutall}>
						<Tooltip title="Выйти на всех устройствах">
							<Icofont icon="logout" />
						</Tooltip>
					</div>
				</div>
			),
		});
		return menu;
	}
	return (
		<Header className="header" style={{ padding: "0 10px", ...lsHeader }}>
			<div style={lsDiv}>
				<div style={{ float: "left" }}>
					<a href="/fed/events" target="_blank" rel="noreferrer noopener">
						<div className={(layout === "web") ? "logo-blue" : "logo"} />
					</a>
				</div>
				<div style={{ float: "right" }}>
					{user && <div style={{ float: "right" }}>

						<Row style={{ cursor: "pointer" }}>
							<Col style={{ lineHeight: "20px", textAlign: "right" }}>
								<Typography style={{ ...lsFontColor, padding: "12px 15px 0px 0px", fontWeight: "600", fontSize: "13px" }}>
									{user.lastname} {user.firstname}
								</Typography>
								<Typography style={{ ...lsFontColor, padding: "0 15px", fontSize: "12px" }}>
									{/* {user.email} */}
									Баланс:
									<Popover placement="bottom" content={<>
										Счет №{_.get(akkauntiPolzovatelei, "[0].akkaunt.nomerAkkaunta")}
									</>} trigger="click">
										<a href="#" style={{ paddingLeft: "3px", color: (balance(akkauntiPolzovatelei) < 0) ? "red" : "#1890ff" }}>
											{balance(akkauntiPolzovatelei).toLocaleString()} руб.
										</a>
									</Popover>
									{/* <Dropdown overlay={<Menu>
										{JSXMap(akkauntiPolzovatelei, (e,idx)=>
										<Menu.Item key={idx}>
											<div style={{display:"flex",justifyContent:"space-between"}}>
												<div>№{_.get(e, "akkaunt.nomerAkkaunta")}</div>
												<div style={{paddingLeft: "14px"}}>{_.get(e, "akkaunt.ostatok").toLocaleString()} руб.</div>
											</div>
											</Menu.Item>
										)}
										</Menu>}>
											<a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
											{balance(akkauntiPolzovatelei).toLocaleString()} руб.
											</a>
										</Dropdown> */}
								</Typography>
							</Col>
							<Col>
								<Dropdown placement='bottomRight' overlay={
									<div style={{ color: "white", borderRadius: "4px" }}>
										<Menu items={_menu()} />
									</div>}>
									<Avatar src={(user?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + user?.avatarMin : undefined} size="large" shape='square' icon={<UserOutlined style={{ padding: 0 }} />} />
									{/* <Avatar shape="square" size="large" icon={(user.avatarMin) ? <Image
										width={40}
										height={40}
										style={{ background: "transparent" }}
										preview={false}
										src={(user.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + user.avatarMin : "error"}
										fallback="data:image/png;base64,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"
									/> : <UserOutlined style={{ color: "gray" }} />} /> */}
								</Dropdown>
							</Col>
						</Row>

					</div>}

				</div>
			</div>
		</Header>
	);
};
const FedSubheader = (props) => {
	const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
	const isMobile = useIsMobileContext();
	const isDesktopOrLaptop = useIsDesktopOrLaptopContext();

	const { layout, fullwidth } = props;
	let fwHeader = (fullwidth || !isDesktopOrLaptop) ? {} : { width: layoutWidth, padding: "0", margin: "0 auto" };
	let lsHeader = (layout === "web") ? { height: "46px", background: "#f6214b", borderRadius: "2px" } : {};
	let lsDiv = (layout === "web") ? { lineHeight: "46px" } : {};

	return (
		<Header className="subheader" style={{ padding: "0 10px", background: "#fff", ...fwHeader, ...lsHeader }}>
			<div style={{ float: 'right', ...lsDiv }}>
				{/* <DropdownAction menuOptions={{ className: "page-menu" }} trigger={['click']} placement="bottomRight" button={() => (
					<Button style={{ padding: "0 10px", marginRight: "10px", ...lsButton }} type="link">
						<MenuOutlined />
					</Button>)}>
					<MenuItem key="2" onClick={changeFullwidth}>
						<div style={{ minWidth: "200px", display: "flex", justifyContent: "space-between" }}>
							<div style={{ flex: "1" }}>
								{!fullwidth ?
									<><FullscreenOutlined />Во весь экран </> :
									<><FullscreenExitOutlined />Уменьшить </>}
							</div>
						</div>
					</MenuItem>
				</DropdownAction> */}
			</div>
		</Header>
	);
};
const PlusMinus = ({ plus, minus }) => {
	return (<div style={{ display: "flex", justifyContent: "center", gap: "5px" }}>
		{!!plus && <div style={{ display: "flex", justifyContent: "space-between" }}>
			<div>
				<span style={{ marginLeft: "-1px" }}>+</span>
				<span style={{ paddingLeft: "1px" }}>:</span>
			</div>
			<div>{plus}</div>
		</div>}
		{!!minus && <div style={{ color: "red", display: "flex", justifyContent: "space-between" }}>
			<div>
				<span>-</span>
				<span style={{ paddingLeft: "3px" }}>:</span>
			</div>
			<div>{minus}</div>
		</div>}
	</div>)
}
const User = ({ user, partner }) => {
	return (<div style={{
		border: "1px solid transparent",
		maxWidth: "208px",
		minWidth: "208px",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
		display: "flex",
		justifyContent: "flex-start",
		gap: "5px",
		alignItems: "center"
	}}>
		<div style={{ backgroundColor: (!!partner) ? "cadetblue" : ((user?.genderID === 1) ? "blue" : "red"), width: "13px", height: "13px", lineHeight: "13px", borderRadius: "3px", textAlign: "center" }}>
			<Icofont icon={(!!partner) ? "users-alt-4" : "user"} style={{ color: "white", fontSize: "8px", marginLeft: "1px" }} />
		</div>
		<div>
			<div>{user?.lastname} {user?.firstname}</div>
			{(!!partner) && <div>{partner?.lastname} {partner?.firstname}</div>}
		</div>
	</div>)
}

function EventResult(props) {
	let navigate = useNavigate();
	let { id } = useParams();
	const auth = useAuth();
	const classes = useStyles();
	const dispatch = useDispatch();
	const { history } = props;

	//-------------------------------------------------------------
	const [layout, setLayout] = useState("web"); // app | web
	const [showContentMenu, setShowContentMenu] = useState(false);
	const [showRightSider, setShowRightSider] = useState(false);
	const [showLeftSider, setShowLeftSider] = useState(false);
	const [showHeader, setShowHeader] = useState(false);
	const [showSubheader, setShowSubheader] = useState(true);
	const [loading, setLoading] = useState(false);
	const [fullwidth, setFullwidth] = useState(false);
	//-------------------------------------------------------------

	const meta = useSelector(state => state.meta);

	// const [collapsed, setCollapsed] = useState(true);
	const [user, setUser] = useState();
	const [event, setEvent] = useState(undefined);
	const [eventResult, setEventResult] = useState();
	const [jackResult, setJackResult] = useState();
	const [jamResult, setJamResult] = useState();
	const [partyResult, setPartyResult] = useState();
	const [byParams, setByParams] = useState("yes");
	const siteAccess = useSelector(state => state.siteAccess.value);

	useEffect(() => {
		subscribe();
		return () => {
			unsubscribe();
		};
	}, []);
	const subscribe = () => {
		auth.fetch('/api/meta').then(res => {
			if (res && res.data && dispatch) {
				dispatch({ type: 'META', payload: res.data })
			}
		});
		auth.fetch('/api/iam').then(res => {
			if (res && res.data) {
				setUser(res.data);
			}
		});
		setLoading(true);
		GET(auth, `/api/meropriyatiya/list/com?detail=model&w-id=${id}`,
			({ data }) => {
				if (data && data.length) {
					setEvent(data[0]);
					setLoading(false);
				}
			}, errorCatch);

		GET(auth, `/api/report/event/${id}/my-result`,
			({ data }) => {
				let v = convertEventResult(data);
				// console.log(v);
				setEventResult(v)
			}, errorCatch);

		GET(auth, `/api/report/event/${id}/jack-my-result`,
			({ data }) => {
				setJackResult(data)
			}, errorCatch);
		GET(auth, `/api/report/event/${id}/jam-my-result`,
			({ data }) => {
				setJamResult(data)
			}, errorCatch);
		GET(auth, `/api/report/event/${id}/party-my-result`,
			({ data }) => {
				setPartyResult(data)
			}, errorCatch);
		RefreshAkkaunti();
		auth.openSocket("/ws/service", "service", function (type, payload) {
			if (type === "reload") {
				window.location.href = window.location.href;
			}
			switch (type) {
				case "siteaccess":
					dispatch({ type: "SITE_ACCESS", payload: payload });
					break;
				case "NeedUpdateAkkauntPolzovatelya":
					RefreshAkkaunti();
					break;
				case "AkkauntiPolzovatelei":
					dispatch(REDUX_AkkauntiPolzovatelei.actions.updateArray([payload]));
					break;
				default:
					break;
			}
		});
	};

	const _RefreshAkkaunti = () => {
		READWITH(auth, "AkkauntiPolzovatelei", [
			QueryDetail("model")
		], ({ data }) => {
			if (data) {
				dispatch(REDUX_AkkauntiPolzovatelei.actions.updateArray(data));
			}
		}, errorCatch);
	};
	var RefreshAkkaunti = _.throttle(_RefreshAkkaunti, 3000, { 'trailing': false });

	const unsubscribe = () => {
		auth.closeSocket("service");
	};
	const logout = () => {
		auth.logout(() => {
			navigate('/app');
			// history.go(0);
		});
	}
	const logoutall = () => {
		auth.logoutall(() => {
			navigate('/app');
			// history.go(0);
		});
	}
	const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
	const isMobile = useIsMobileContext();
	const isDesktopOrLaptop = useIsDesktopOrLaptopContext();
	const style = () => {
		return {
			fullwidth: {
				layout: (fullwidth || !isDesktopOrLaptop) ? {} : { width: layoutWidth, margin: "0 auto" },
				header: (fullwidth || !isDesktopOrLaptop) ? {} : { width: layoutWidth, padding: "0", margin: "0 auto" },
			},
			content: {
				minHeight: 600,
				paddingTob: "0px",
				paddingRight: (!showRightSider) ? "0px" : "10px",
				paddingBottom: "0px",
				paddingLeft: (!showLeftSider) ? "0px" : "10px",
				// background: "white"
			}
		}
	};
	const changeFullwidth = () => {
		setFullwidth(!fullwidth ? true : false);
	};

	return (
		<MetaContext.Provider value={meta}>
			{(!siteAccess || siteAccess == "allow") && <Layout>
				<FedHeader user={user} logout={logout} logoutall={logoutall} layout={layout} fullwidth={fullwidth} />
				{showSubheader && <FedSubheader layout={layout} fullwidth={fullwidth} changeFullwidth={changeFullwidth} />}
				<Content style={{ padding: '10px 10px 0 10px' }}>
					<Layout style={style().fullwidth.layout}>
						{showLeftSider && <Sider theme="light"></Sider>}
						<Content style={{ ...style().content }}>
							<div style={{ display: "flex", justifyContent: "space-between" }}>
								<div style={{ flex: "1 1 auto", overflow: "hidden" }}>
									{showHeader && <Row gutter={[5, 5]}>
										<Col span={24}>
											<Card size="small" bordered={false} className={classes.block}>Header</Card>
										</Col>
									</Row>}
									<Row gutter={[5, 5]}>
										<Col span={24}>
											<Card size="small" bordered={false} className={classes.block}>
												<Spin spinning={loading}>
													<div style={{ height: "100%", backgroundColor: "white", padding: "0 15px", borderRadius: "4px" }}>
														{event && <div style={{ textAlign: "center", padding: "15px" }}>
															<div style={{ fontSize: "16px", fontWeight: "100" }}>Ваши оценки на мероприятии</div>
															<div style={{ fontSize: "22px", fontWeight: "600", lineHeight: "22px" }}>
																<a href={`/fed/event/${id}`}>{event?.nazvanieMeropriyatiya}</a>
															</div>
															<div style={{ fontSize: "18px", fontWeight: "600", lineHeight: "30px" }}>г. {event?.mestoProvedeniya?.name}</div>
														</div>}
														{event && <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "15px", paddingBottom: "25px" }}>
															<div style={{ flex: "0 0 250px", maxWidth: "250px" }}>
																<div style={{ width: "250px", height: "250px", overflow: "hidden", borderRadius: "6px" }}>
																	<YImage item={event} width={250} />
																</div>
																<div style={{ marginTop: "7px" }}>
																	<div style={{
																		backgroundColor: "#eaeaea",
																		fontSize: "16px",
																		fontWeight: "400",
																		color: "black",
																		borderRadius: "6px",
																		textAlign: "center",
																		padding: "0 7px",
																		textAlign: "center",
																	}}>
																		<div style={{
																			borderRadius: "5px",
																			backgroundColor: "#f6214b",
																			fontSize: "12px",
																			fontWeight: "600",
																			color: "white",
																			margin: "0 -7px",
																			boxShadow: "0px 6px 5px -5px rgb(34 60 80 / 60%",
																			padding: "3px 7px"
																		}}>
																			{dayjs(event?.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}
																		</div>
																		<div style={{
																			fontSize: "10px",
																			fontWeight: "400",
																			padding: "0px"
																		}}>
																			{dayjs(event?.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
																		</div>
																	</div>
																</div>
															</div>

															{jackResult && <div style={{}}>
																{JSXMap(jackResult, (item, idx) => {

																	return (
																		<div key={idx}>
																			<div className={`bg bg-grey`} style={{ padding: "5px", position: "relative" }}>
																				<div style={{ fontWeight: "bold" }}>{item?.myResult?.dancerEvent?.kategoriiUchastnikovNaMeropriyatiyakh?.tantsevalnayaDistsiplinaPsevdonim || item?.myResult?.dancerEvent?.kategoriiUchastnikovNaMeropriyatiyakh?.tantsevalnayaDistsiplina?.nazvanie}</div>
																				<div style={{ fontWeight: "bold" }}>{item?.myResult?.dancerEvent?.kategoriiUchastnikovNaMeropriyatiyakh?.kategoriyaUchastnikovPsevdonim || item?.myResult?.dancerEvent?.kategoriiUchastnikovNaMeropriyatiyakh?.kategoriyaUchastnikov?.nazvanie}</div>
																				<div>{(item?.myResult?.dancerEvent?.tipTDID == 2) ? "Пара" : "Участник"} {`№${item?.myResult?.dancerEvent?.number}`}, {`${item?.myResult?.user?.lastname} ${item?.myResult?.user?.firstname}`}{(item?.myResult?.dancerEvent?.tipTDID == 2) ? (" - " + item?.myResult?.partner?.lastname + " " + item?.myResult?.partner?.firstname) : ""} </div>
																			</div>
																			<div className='scrollable'>
																				<table className="table" style={{ fontSize: "12px" }}>
																					<thead>
																						<tr>
																							<th className={`wrap fixed`} style={{ minWidth: "210px" }}>
																								<div className='bg bg-grey dark-1'></div>
																							</th>
																							<th className="wrap fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																								<div className='bg bg-grey dark-1' style={{ fontWeight: "bold" }}>Место</div>
																							</th>
																							<th className="wrap fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																								<div className='bg bg-grey dark-1'>Очки</div>
																							</th>
																						</tr>

																					</thead>

																					<tbody style={{ fontSize: "12px" }}>
																						{(item?.firstPlace?.userID != item?.myResult?.userID) && <tr>
																							<td className={`fixed`} style={{ minWidth: "210px" }}>
																							</td>
																							<td className="fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																								<div className="bg bg-blue" style={{ fontWeight: "bold" }}>
																									{item?.firstPlace?.place}
																								</div>
																							</td>
																							<td className="fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																								<div className="bg bg-blue">
																									{item?.firstPlace?.resultPoints}
																								</div>
																							</td>
																						</tr>}
																						<tr>
																							<td className={`fixed fill`} style={{ minWidth: "210px" }}>
																								<User user={item?.myResult?.user} partner={(item?.myResult?.dancerEvent?.tipTDID == 2) ? (item?.myResult?.partner) : undefined} />
																							</td>
																							<td className="fixed fill" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																								<div className="bg bg-blue dark-3" style={{ fontWeight: "bold" }}>
																									{item?.myResult?.place}
																								</div>
																							</td>
																							<td className="fixed fill" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																								<div className="bg bg-blue dark-3">
																									{item?.myResult?.resultPoints}
																								</div>
																							</td>
																						</tr>
																						{(item?.lastPlace?.userID != item?.myResult?.userID) && <tr>
																							<td className={`fixed`} style={{ minWidth: "210px" }}>
																							</td>
																							<td className="fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																								<div className="bg bg-blue" style={{ fontWeight: "bold" }}>
																									{item?.lastPlace?.place}
																								</div>
																							</td>
																							<td className="fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																								<div className="bg bg-blue">
																									{item?.lastPlace?.resultPoints}
																								</div>
																							</td>
																						</tr>}
																					</tbody>


																				</table>
																			</div>
																		</div>
																	)
																})}
															</div>}

															{eventResult && <div style={{ width: "100%" }}>
																{JSXMap(eventResult?.kategorii?.kategorii, (item, idx) => (
																	<div key={idx}>
																		<div className={`bg bg-grey`} style={{ padding: "5px", position: "relative" }}>
																			<div style={{ fontWeight: "bold" }}>{item?.kategoriyaUchastnikovNaMeropriyatii?.tantsevalnayaDistsiplina?.nazvanie}</div>
																			<div style={{ fontWeight: "bold" }}>{item?.kategoriyaUchastnikovNaMeropriyatii?.kategoriyaUchastnikov?.nazvanie}</div>
																			<div>{(item?.dancerEvent?.tipTDID == 2) ? "Пара" : "Участник"} {`№${item?.dancerEvent?.number}`}, {`${item?.dancerEvent?.user?.lastname} ${item?.dancerEvent?.user?.firstname}`}{(item?.dancerEvent?.tipTDID == 2) ? (" - " + item?.dancerEvent?.partner?.lastname + " " + item?.dancerEvent?.partner?.firstname) : ""} </div>
																		</div>
																		{JSXMap(item?.tours, (tourItem, tidx) => <div key={tidx} >
																			<div className={`bg bg-blue dark-1`} onClick={(e) => { e.stopPropagation(); e.preventDefault(); }} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "2px" }}>
																				<div style={{ flex: "1 1 auto", fontWeight: "bold", padding: "0 2px" }}> Тур {`${tourItem?.tour?.number} (${tourItem?.tour?.tourType?.name})`}</div>
																			</div>
																			<div className='scrollable'>
																				<table className="table" style={{ fontSize: "13px" }}>
																					<thead>
																						<tr>
																							<th className={`wrap fixed`} style={{ minWidth: "210px" }} rowSpan="2">
																								<div className='bg bg-grey dark-1'>Судья</div>
																							</th>
																							<th className="wrap fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }} rowSpan="2">
																								<div className='bg bg-grey dark-1'>Итого</div>
																							</th>
																							{JSXMap(tourItem?.criterionView, (criterionItem, cidx) =>
																								<th className="wrap" style={{ fontWeight: "300" }} key={cidx} colSpan={criterionItem?.criterionParams?.length}>
																									<div className="bg bg-grey">
																										{criterionItem?.criterion?.name}
																									</div>
																								</th>
																							)}
																						</tr>
																						<tr>
																							{JSXMap(tourItem?.criterionView, (criterionItem, cidx) =>
																								<React.Fragment key={cidx}>
																									{JSXMap(criterionItem?.criterionParams, (param, cxidx) => {
																										let color = getIndexColorLighter(cidx, 0.125);
																										return (<th className="wrap" key={cxidx}>
																											<div className="bg bg-grey" style={{ backgroundColor: color }}>
																												{param?.criterionParams?.name}
																											</div>
																										</th>)
																									})}
																								</React.Fragment>
																							)}
																						</tr>
																						{(tourItem?.tour?.protocolValueTypeID === 1) &&
																							<tr className="tr-rounded">
																								<th className={`fixed`} style={{ minWidth: "210px" }}>
																									{/* Итого */}
																								</th>
																								<th className="fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																									<div className="bg bg-blue">
																										<PlusMinus plus={tourItem?.plus} minus={tourItem?.minus} />
																									</div>
																								</th>
																								{JSXMap(tourItem?.criterionView, (criterionItem, cidx) =>
																									<React.Fragment key={cidx}>
																										{JSXMap(criterionItem?.criterionParams, (param, cidx) =>
																											<th key={cidx}>
																												<div className="bg bg-blue">
																													<PlusMinus plus={param?.plus} minus={param?.minus} />
																												</div>
																											</th>
																										)}
																									</React.Fragment>
																								)}

																							</tr>}
																						{(tourItem?.tour?.protocolValueTypeID !== 1) &&
																							<tr className="tr-rounded">
																								<th className={`fixed`} style={{ minWidth: "210px" }}>
																									{/* Итого */}
																								</th>
																								<th className="fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																									<div className="bg bg-blue">
																										{tourItem?.plus}
																									</div>
																								</th>
																								{JSXMap(tourItem?.criterionView, (criterionItem, cidx) =>
																									<React.Fragment key={cidx}>
																										{JSXMap(criterionItem?.criterionParams, (param, cidx) =>
																											<th key={cidx}>
																												<div className="bg bg-blue">
																													{param?.plus}
																												</div>
																											</th>
																										)}
																									</React.Fragment>
																								)}

																							</tr>}
																					</thead>
																					{(tourItem?.tour?.protocolValueTypeID === 1) &&
																						<tbody style={{ fontSize: "12px" }}>
																							{JSXMap(tourItem?.judgeView, (judgeItem, cidx) =>
																								<tr key={cidx}>
																									<td className={`fixed`} style={{ minWidth: "210px" }}>
																										<User user={judgeItem?.judge} />
																									</td>
																									<td className="fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																										<div className="bg bg-blue">
																											<PlusMinus plus={judgeItem?.plus} minus={judgeItem?.minus} />
																										</div>
																									</td>
																									{JSXMap(judgeItem?.criterions, (criterion, cidx) =>
																										<React.Fragment key={cidx}>
																											{JSXMap(criterion?.protocolDancerParams, (protocolDancerParam, cidx) => {
																												if (protocolDancerParam.value && protocolDancerParam.value > 0) {
																													return (<td key={cidx}>
																														<div className="bg bg-green dark-3">+</div>
																													</td>)
																												} else if (protocolDancerParam.value && protocolDancerParam.value < 0) {
																													return (<td key={cidx}>
																														<div className="bg bg-red dark-1">-</div>
																													</td>)
																												} else {
																													return (<td key={cidx}>
																														<div className="bg bg-grey"></div>
																													</td>)
																												}
																											})}
																										</React.Fragment>
																									)}

																								</tr>
																							)}
																						</tbody>
																					}
																					{(tourItem?.tour?.protocolValueTypeID !== 1) &&
																						<tbody style={{ fontSize: "12px" }}>
																							{JSXMap(tourItem?.judgeView, (judgeItem, cidx) =>
																								<tr key={cidx}>
																									<td className={`fixed`} style={{ minWidth: "210px" }}>
																										<User user={judgeItem?.judge} />
																									</td>
																									<td className="fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																										<div className="bg bg-blue">
																											{judgeItem?.plus}
																										</div>
																									</td>
																									{JSXMap(judgeItem?.criterions, (criterion, cidx) =>
																										<React.Fragment key={cidx}>
																											{JSXMap(criterion?.protocolDancerParams, (protocolDancerParam, cidx) => {
																												let weight = protocolDancerParam?.criterionParams?.weight || 1
																												if ((protocolDancerParam.protocolDancer?.protocol?.genderID == 1 && tourItem?.tour?.raspredSudeiPoKriteriyamMID == 3) ||
																													(protocolDancerParam.protocolDancer?.protocol?.genderID == 2 && tourItem?.tour?.raspredSudeiPoKriteriyamWID == 3)) {
																													weight = 1
																												}

																												if (protocolDancerParam.value) {
																													return (<td key={cidx}>
																														<div className="bg bg-green dark-3">{protocolDancerParam.value * weight}</div>
																													</td>)
																												} else {
																													return (<td key={cidx}>
																														<div className="bg bg-grey">0</div>
																													</td>)
																												}
																											})}
																										</React.Fragment>
																									)}

																								</tr>
																							)}
																						</tbody>}
																				</table>
																			</div>
																		</div>)}
																	</div>
																))}
															</div>}

															{jamResult && <div style={{}}>
																{JSXMap(jamResult, (item, idx) => {

																	return (
																		<div key={idx}>
																			<div className={`bg bg-grey`} style={{ padding: "5px", position: "relative" }}>
																				<div style={{ fontWeight: "bold" }}>{item?.myResult?.dancerEvent?.kategoriiUchastnikovNaMeropriyatiyakh?.tantsevalnayaDistsiplinaPsevdonim || item?.myResult?.dancerEvent?.kategoriiUchastnikovNaMeropriyatiyakh?.tantsevalnayaDistsiplina?.nazvanie}</div>
																				<div style={{ fontWeight: "bold" }}>{item?.myResult?.dancerEvent?.kategoriiUchastnikovNaMeropriyatiyakh?.kategoriyaUchastnikovPsevdonim || item?.myResult?.dancerEvent?.kategoriiUchastnikovNaMeropriyatiyakh?.kategoriyaUchastnikov?.nazvanie}</div>
																				<div>Участник: {(item?.myResult?.dancerEvent?.number) ? `№${item?.myResult?.dancerEvent?.number}, ` : ""}{`${item?.myResult?.user?.lastname} ${item?.myResult?.user?.firstname}`}</div>
																			</div>
																			<div className='scrollable'>
																				<table className="table" style={{ fontSize: "12px" }}>
																					<thead>
																						<tr>
																							<th className={`wrap fixed`} style={{ minWidth: "210px" }}>
																								<div className='bg bg-grey dark-1'></div>
																							</th>
																							<th className="wrap fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																								<div className='bg bg-grey dark-1' style={{ fontWeight: "bold" }}>Место</div>
																							</th>
																							<th className="wrap fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																								<div className='bg bg-grey dark-1'>Очки</div>
																							</th>
																						</tr>

																					</thead>

																					<tbody style={{ fontSize: "12px" }}>
																						{(item?.firstPlace?.userID != item?.myResult?.userID) && <tr>
																							<td className={`fixed`} style={{ minWidth: "210px" }}>
																							</td>
																							<td className="fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																								<div className="bg bg-blue" style={{ fontWeight: "bold" }}>
																									{item?.firstPlace?.place}
																								</div>
																							</td>
																							<td className="fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																								<div className="bg bg-blue">
																									{item?.firstPlace?.resultPoints}
																								</div>
																							</td>
																						</tr>}
																						<tr>
																							<td className={`fixed`} style={{ minWidth: "210px" }}>
																								<User user={item?.myResult?.user} />
																							</td>
																							<td className="fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																								<div className="bg bg-blue dark-3" style={{ fontWeight: "bold" }}>
																									{item?.myResult?.place}
																								</div>
																							</td>
																							<td className="fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																								<div className="bg bg-blue dark-3">
																									{item?.myResult?.resultPoints}
																								</div>
																							</td>
																						</tr>
																						{(item?.lastPlace?.userID != item?.myResult?.userID) && <tr>
																							<td className={`fixed`} style={{ minWidth: "210px" }}>
																							</td>
																							<td className="fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																								<div className="bg bg-blue" style={{ fontWeight: "bold" }}>
																									{item?.lastPlace?.place}
																								</div>
																							</td>
																							<td className="fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																								<div className="bg bg-blue">
																									{item?.lastPlace?.resultPoints}
																								</div>
																							</td>
																						</tr>}
																					</tbody>


																				</table>
																			</div>
																		</div>
																	)
																})}
															</div>}

															{partyResult && <div style={{ width: "100%" }}>
																{JSXMap(partyResult, (item, idx) => {

																	let common = item?.myResult?.dancerTourPartyResultsDancerTourParty?.filter((e) => e.type == 0)
																	let criterions = item?.myResult?.dancerTourPartyResultsDancerTourParty?.filter((e) => e.type == 1)
																	let parameters = item?.myResult?.dancerTourPartyResultsDancerTourParty?.filter((e) => e.type == 2)

																	return (
																		<div key={idx}>
																			<div className={`bg bg-grey`} style={{ padding: "5px", position: "relative" }}>
																				<div style={{ fontWeight: "bold" }}>{item?.myResult?.dancerEvent?.kategoriiUchastnikovNaMeropriyatiyakh?.tantsevalnayaDistsiplinaPsevdonim || item?.myResult?.dancerEvent?.kategoriiUchastnikovNaMeropriyatiyakh?.tantsevalnayaDistsiplina?.nazvanie}</div>
																				<div style={{ fontWeight: "bold" }}>{item?.myResult?.dancerEvent?.kategoriiUchastnikovNaMeropriyatiyakh?.kategoriyaUchastnikovPsevdonim || item?.myResult?.dancerEvent?.kategoriiUchastnikovNaMeropriyatiyakh?.kategoriyaUchastnikov?.nazvanie}</div>
																				<div>Участник: {(item?.myResult?.dancerEvent?.number) ? `№${item?.myResult?.dancerEvent?.number}, ` : ""}{`${item?.myResult?.user?.lastname} ${item?.myResult?.user?.firstname}`}</div>
																			</div>

																			<div className='scrollable'>
																				<table className="table" style={{ fontSize: "12px" }}>
																					<thead>
																						<tr>
																							<th className={`wrap fixed`} style={{ minWidth: "210px" }} rowSpan="4">
																								<div className='bg bg-grey dark-1'></div>
																							</th>
																							<th className="wrap fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }} rowSpan="4">
																								<div className='bg bg-grey dark-1'>Место</div>
																							</th>
																							{common?.length && <th className="wrap" style={{ fontWeight: "bold" }} colSpan={common?.length}>
																								<div className={`bg bg-grey`}>

																								</div>
																							</th>}
																							{criterions?.length && <th className="wrap" style={{ fontWeight: "bold" }} colSpan={criterions?.length}>
																								<div className={`bg bg-grey dark-3`}>
																									в том числе по критериям в порядке приоритета:
																								</div>
																							</th>}
																							{parameters?.length && <th className="wrap" style={{ fontWeight: "bold" }} colSpan={parameters?.length}>
																								<div className={`bg bg-grey`}>
																									в том числе по параметрам критериев в порядке приоритета:
																								</div>
																							</th>}
																						</tr>
																						<tr>
																							{/* <th className={`wrap fixed`} style={{ minWidth: "210px" }} rowSpan="2">
																								<div className='bg bg-grey dark-1'></div>
																							</th>
																							<th className="wrap fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }} rowSpan="2">
																								<div className='bg bg-grey dark-1'>Место</div>
																							</th> */}

																							{common?.length && JSXMap(common, (xitem, cidx) =>
																								<th className="wrap" style={{ fontWeight: "bold" }} key={cidx} rowSpan="3">
																									<div className={`bg bg-grey`}>
																										{xitem?.name}
																									</div>
																								</th>
																							)}

																							{criterions?.length && JSXMap(criterions, (xitem, cidx) => {
																								let color = getIndexColorLighter(cidx, 0.125);
																								return (<th className="wrap" style={{ fontWeight: "bold" }} key={cidx} rowSpan="3">
																									<div className={`bg bg-grey`} style={{ backgroundColor: color }}>
																										{xitem?.name}
																									</div>
																								</th>)
																							})}
																							{parameters?.length && JSXMap(parameters, (xitem, cidx) =>
																								<th className="wrap" style={{ fontWeight: "bold" }} key={cidx}>
																									<div className={`bg bg-grey`}>
																										{xitem?.criterion?.name?.[0]}
																									</div>
																								</th>
																							)}

																						</tr>
																						<tr>
																							{/* <th className={`wrap fixed`} style={{ minWidth: "210px" }} rowSpan="2">
																								<div className='bg bg-grey dark-1'></div>
																							</th>
																							<th className="wrap fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }} rowSpan="2">
																								<div className='bg bg-grey dark-1'>Место</div>
																							</th> */}

																							{/* {common?.length && JSXMap(common, (xitem, cidx) =>
																								<th className="wrap" style={{ fontWeight: "bold" }} key={cidx} rowSpan="2">
																									<div className={`bg bg-grey`}>
																										{xitem?.name}
																									</div>
																								</th>
																							)}
																							{criterions?.length && JSXMap(criterions, (xitem, cidx) =>
																								<th className="wrap" style={{ fontWeight: "bold" }} key={cidx} rowSpan="2">
																									<div className={`bg bg-grey`}>
																										{xitem?.name}
																									</div>
																								</th>
																							)} */}
																							{parameters?.length && JSXMap(parameters, (xitem, cidx) =>
																								<th className="wrap" style={{ fontWeight: "bold" }} key={cidx}>
																									<div className={`bg bg-grey`}>
																										{xitem?.name}
																									</div>
																								</th>
																							)}

																						</tr>
																						<tr>
																							{/* <th className={`wrap fixed`} style={{ minWidth: "210px" }} rowSpan="2">
																								<div className='bg bg-grey dark-1'></div>
																							</th>
																							<th className="wrap fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }} rowSpan="2">
																								<div className='bg bg-grey dark-1'>Место</div>
																							</th> */}

																							{/* {common?.length && JSXMap(common, (xitem, cidx) =>
																								<th className="wrap" style={{ fontWeight: "bold" }} key={cidx} rowSpan="2">
																									<div className={`bg bg-grey`}>
																										{xitem?.name}
																									</div>
																								</th>
																							)}
																							{criterions?.length && JSXMap(criterions, (xitem, cidx) =>
																								<th className="wrap" style={{ fontWeight: "bold" }} key={cidx} rowSpan="2">
																									<div className={`bg bg-grey`}>
																										{xitem?.name}
																									</div>
																								</th>
																							)} */}
																							{parameters?.length && JSXMap(parameters, (xitem, cidx) =>
																								<th className="wrap" style={{ fontWeight: "bold" }} key={cidx}>
																									<div className={`bg bg-grey`}>
																										Вес: {xitem?.weight}
																									</div>
																								</th>
																							)}

																						</tr>
																						{/* <tr>
																						{JSXMap(item?.myResult?.dancerTourPartyResultsDancerTourParty, (criterionItem, cidx) =>
																							<React.Fragment key={cidx}>
																								{JSXMap(criterionItem?.criterionParams, (param, cxidx) => {
																									let color = getIndexColorLighter(cidx, 0.125);
																									return (<th className="wrap" key={cxidx}>
																										<div className="bg bg-grey" style={{ backgroundColor: color }}>
																											{param?.criterionParams?.name}
																										</div>
																									</th>)
																								})}
																							</React.Fragment>
																						)}
																					</tr> */}

																						{/* <tr className="tr-rounded">
																							<th className={`fixed`} style={{ minWidth: "210px" }}>

																							</th>
																							<th className="fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																								<div className="bg bg-blue">
																									<PlusMinus plus={tourItem?.plus} minus={tourItem?.minus} />
																								</div>
																							</th>
																							{JSXMap(item?.myResult?.dancerTourPartyResultsDancerTourParty, (criterionItem, cidx) =>
																								<React.Fragment key={cidx}>
																									{JSXMap(criterionItem?.criterionParams, (param, cidx) =>
																										<th key={cidx}>
																											<div className="bg bg-blue">
																												<PlusMinus plus={param?.plus} minus={param?.minus} />
																											</div>
																										</th>
																									)}
																								</React.Fragment>
																							)}

																						</tr> */}

																					</thead>

																					<tbody style={{ fontSize: "12px" }}>
																						{(item?.firstPlace?.userID != item?.myResult?.userID) && <tr>
																							<td className={`fixed`} style={{ minWidth: "210px" }}>
																								{/* <User user={item?.firstPlace?.user} /> */}
																							</td>
																							<td className="fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																								<div className="bg bg-blue">
																									{item?.firstPlace?.place}
																								</div>
																							</td>
																							{JSXMap(item?.firstPlace?.dancerTourPartyResultsDancerTourParty, (zitem, cidx) =>
																								<React.Fragment key={cidx}>
																									<td key={cidx}>
																										{zitem?.value && <div className="bg bg-green">{Math.round(zitem?.value * 100) / 100}</div>}
																										{!zitem?.value && <div className="bg bg-grey"></div>}
																									</td>
																								</React.Fragment>
																							)}

																						</tr>}
																						<tr>
																							<td className={`fixed`} style={{ minWidth: "210px" }}>
																								<User user={item?.myResult?.user} />
																							</td>
																							<td className="fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																								<div className="bg bg-blue dark-3">
																									{item?.myResult?.place}
																								</div>
																							</td>
																							{JSXMap(item?.myResult?.dancerTourPartyResultsDancerTourParty, (zitem, cidx) =>
																								<React.Fragment key={cidx}>
																									<td key={cidx}>
																										{zitem?.value && <div className="bg bg-green dark-3">{Math.round(zitem?.value * 100) / 100}</div>}
																										{!zitem?.value && <div className="bg bg-grey dark-3"></div>}
																									</td>
																								</React.Fragment>
																							)}
																						</tr>
																						{(item?.lastPlace?.userID != item?.myResult?.userID) && <tr>
																							<td className={`fixed`} style={{ minWidth: "210px" }}>
																								{/* <User user={item?.lastPlace?.user} /> */}
																							</td>
																							<td className="fixed" style={{ left: "210px", minWidth: "70px", maxWidth: "70px" }}>
																								<div className="bg bg-blue">
																									{item?.lastPlace?.place}
																								</div>
																							</td>
																							{JSXMap(item?.lastPlace?.dancerTourPartyResultsDancerTourParty, (zitem, cidx) =>
																								<React.Fragment key={cidx}>
																									<td key={cidx}>
																										{zitem?.value && <div className="bg bg-green">{Math.round(zitem?.value * 100) / 100}</div>}
																										{!zitem?.value && <div className="bg bg-grey"></div>}
																									</td>
																								</React.Fragment>
																							)}
																						</tr>}
																					</tbody>


																				</table>
																			</div>


																		</div>
																	)
																})}
															</div>}

														</div>}
													</div>
												</Spin>
											</Card>
										</Col>
									</Row>
								</div>
							</div>
						</Content>
						{showRightSider && <Sider width={185} theme={"light"}></Sider>}
					</Layout>
				</Content>
				<Footer style={{ textAlign: 'center' }}>
					Общероссийская физкультурно-спортивная общественная организация "Всероссийская федерация социальных танцев"
				</Footer>
			</Layout >}
		</MetaContext.Provider >
	);
};

export default React.memo(EventResult);
// Payment.whyDidYouRender = true